/* 🤖 this file was generated by svg-to-ts */
export const matIconSwipeUpAlt: {
  name: 'swipe-up-alt';
  data: string;
} = {
  name: 'swipe-up-alt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m13 5.83 1.59 1.59L16 6l-4-4-4 4 1.41 1.41L11 5.83v4.27a5 5 0 1 0 2 0V5.83zM12 18c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"/></svg>`
};
